// Utils
import { type DataJournalType, getDiscount } from "pages/Finance/Transaction/utils"

export function getAcc(
  datajournal: DataJournalType[],
  isTaxInclusive: boolean
) {
  // Functions
  const getSubtotal = (item: DataJournalType): number => {
    if (isTaxInclusive) {
      return item.amount - getDiscount(item.amount, item.rate)
    }

    return item.amount
  }

  return {
    sub_total: Math.round(datajournal.reduce((acc, item) => acc + getSubtotal(item), 0)),
    tax: Math.round(datajournal.reduce((acc, item) => acc + getDiscount(item.amount, item.rate), 0))
  }
}